import React from 'react';
interface PaxStatementNotesProps {
  externalNotes?: string;
  termsAndConditions?: string;
  termsUrl?: string;
  showDeclaration?: boolean;
  bookingStaffName?: string;
}
export function PaxStatementNotes({
  externalNotes,
  termsAndConditions,
  termsUrl,
  showDeclaration = true,
  bookingStaffName
}: PaxStatementNotesProps) {
  return <div className="mb-6 space-y-5" data-id="element-759">
      {/* External Notes */}
      {externalNotes && <div data-id="element-760">
          <h3 className="text-xs font-bold text-neutral-900 uppercase tracking-wide mb-2" data-id="element-761">
            External Notes
          </h3>
          <div className="bg-neutral-50 border border-neutral-200 rounded-lg p-4" data-id="element-762">
            <p className="text-xs text-neutral-700 leading-relaxed whitespace-pre-line" data-id="element-763">
              {externalNotes}
            </p>
          </div>
        </div>}

      {/* Terms & Conditions */}
      {termsAndConditions && <div data-id="element-764">
          <div className="flex items-center justify-between mb-2" data-id="element-765">
            <h3 className="text-xs font-bold text-neutral-900 uppercase tracking-wide" data-id="element-766">
              Terms & Conditions
            </h3>
            {termsUrl && <a href={termsUrl} target="_blank" rel="noopener noreferrer" className="text-xs text-blue-600 hover:underline" data-id="element-767">
                See full T&C
              </a>}
          </div>
          <div className="bg-neutral-50 border border-neutral-200 rounded-lg p-4" data-id="element-768">
            <p className="text-xs text-neutral-700 leading-relaxed whitespace-pre-line" data-id="element-769">
              {termsAndConditions}
            </p>
          </div>
        </div>}

      {/* Declaration - Only show if enabled */}
      {showDeclaration && <div data-id="element-770">
          <h3 className="text-xs font-bold text-neutral-900 uppercase tracking-wide mb-2" data-id="element-771">
            Declaration
          </h3>
          <div className="bg-neutral-50 border border-neutral-200 rounded-lg p-4" data-id="element-772">
            <p className="text-xs text-neutral-700 leading-relaxed mb-3" data-id="element-773">
              I/We have been advised to purchase travel insurance against
              insolvency of the travel agent. I/We:
            </p>
            <div className="space-y-2.5 mb-5 text-xs text-neutral-700" data-id="element-774">
              <label className="flex items-center gap-3" data-id="element-775">
                <input type="checkbox" className="w-4 h-4 rounded border-neutral-300" data-id="element-776" />
                <span data-id="element-777">Have purchased travel insurance through the agent</span>
              </label>
              <label className="flex items-center gap-3" data-id="element-778">
                <input type="checkbox" className="w-4 h-4 rounded border-neutral-300" data-id="element-779" />
                <span data-id="element-780">Will purchase travel insurance myself</span>
              </label>
              <label className="flex items-center gap-3" data-id="element-781">
                <input type="checkbox" className="w-4 h-4 rounded border-neutral-300" data-id="element-782" />
                <span data-id="element-783">Do not wish to be insured</span>
              </label>
            </div>

            {/* Signature Row - Two Column Layout */}
            <div className="grid grid-cols-2 gap-8 mt-6 pt-5 border-t border-neutral-200" data-id="element-784">
              {/* Left Column - Passenger (3 lines to fill) */}
              <div className="space-y-3" data-id="element-785">
                <div className="flex items-center gap-4" data-id="element-786">
                  <span className="text-xs text-neutral-600 w-20" data-id="element-787">
                    Signature:
                  </span>
                  <div className="flex-1 border-b-2 border-neutral-300 h-10" data-id="element-788"></div>
                </div>
                <div className="flex items-center gap-4" data-id="element-789">
                  <span className="text-xs text-neutral-600 w-20" data-id="element-790">Name:</span>
                  <div className="flex-1 border-b-2 border-neutral-300 h-10" data-id="element-791"></div>
                </div>
                <div className="flex items-center gap-4" data-id="element-792">
                  <span className="text-xs text-neutral-600 w-20" data-id="element-793">Date:</span>
                  <div className="flex-1 border-b-2 border-neutral-300 h-10" data-id="element-794"></div>
                </div>
              </div>

              {/* Right Column - Sales Staff (display only) */}
              <div data-id="element-795">
                <div className="flex items-center justify-between mb-2" data-id="element-796">
                  <span className="text-xs text-neutral-600" data-id="element-797">Sales Staff:</span>
                  <span className="text-xs font-semibold text-neutral-900" data-id="element-798">
                    {bookingStaffName || 'N/A'}
                  </span>
                </div>
                <div className="border-b-2 border-neutral-300 h-10" data-id="element-799"></div>
              </div>
            </div>
          </div>
        </div>}
    </div>;
}